import React, {useRef} from 'react';
import styles from './GroupSuggest.module.scss';
import {Suggest} from 'uikit';
import {FormFields} from '@/utils/FormFields/FormFields';
import {PromocodeGroupsServiceSchema} from "@/services/PromocodeGroupsService/PromocodeGroupsService.schema";
import {
    GroupSuggestPropsInterface
} from "@/views/Admin/Events/Event/Promocodes/GroupSuggest/GroupSuggest.props.interface";
import {generateHash} from "@/utils/generateHash";
import {hasEmoji} from "@/views/Admin/Events/Event/Promocodes/Form/ValidateEmoji";

const GroupSuggest = ({data, onChange}: GroupSuggestPropsInterface) => {
    const fields = FormFields(data.fields);
    const field = fields.build().groupId;
    const value = field.value?.toString().trim() || '';
    const variant = field.variants[value]
    const entries = Object.entries(field.variants);
    const hash = generateHash()
    const inputRef = useRef(variant?.name || '')
    const normalized = inputRef.current.trim().toLowerCase()
    const matched = entries.filter(([_, v]) => v.name?.toLowerCase().includes(normalized));
    const hasExactMatch = Object.values(field.variants).some((v) => v.name?.trim().toLowerCase() === normalized);

    const handleInput = ({target}) => {
        const nextValue = target.value;
        if (hasEmoji(nextValue)) {
            return;
        }

        onChange(prev => ({
            ...prev,
            isFormChanged: true,
            fields: FormFields(prev.fields)
                .setKey('value', {groupId: nextValue})
                .build()
        }));
        inputRef.current = nextValue;
    };

    const handleClick = (variant) => {
        const value = variant.id || variant.hash;
        onChange(prev => ({
            ...prev,
            isFormChanged: true,
            fields: {
                ...FormFields(prev.fields).setKey('value', {groupId: value}).build(),
                groupId: {
                    ...prev.fields.groupId,
                    value,
                    isChanged: true,
                    error: null,
                }
            }
        }));
        inputRef.current = variant.name;
    };


    const handleCreateGroup = () => {
        if (hasEmoji(inputRef.current)) {
            return; // не создаём группу с эмодзи в имени
        }

        onChange(prev => ({
            ...prev,
            isFormChanged: true,
            fields: {
                ...FormFields({
                    ...prev.fields,
                    groupId: {
                        ...prev.fields.groupId,
                        value: hash,
                        variants: {
                            ...prev.fields.groupId.variants,
                            [hash]: {
                                ...PromocodeGroupsServiceSchema,
                                name: inputRef.current,
                            }
                        },
                    }
                }).build(),
                groupId: {
                    ...prev.fields.groupId,
                    value: hash,
                    isChanged: true,
                    error: null,
                    variants: {
                        ...prev.fields.groupId.variants,
                        [hash]: {
                            ...PromocodeGroupsServiceSchema,
                            name: inputRef.current,
                        }
                    }
                }
            }
        }));
    };


    return (
        <Suggest
            label={field.label}
            placeholder={field.placeholder}
            value={inputRef.current}
            onChange={() => null}
            onInput={handleInput}
            onClick={() => null}
            onDropShow={() => null}
            onDropHide={() => null}
            isClearable={true}
            data={[
                ...matched.map(([_, v], i) => <div
                    key={i}
                    className={styles.item}
                    onClick={() => handleClick(v)}>
                    {v.name}
                </div>),
                !hasExactMatch && inputRef.current &&
                <div key={'create'} className={styles.item} onClick={handleCreateGroup}>
                    Новая группа «{inputRef.current}»
                </div>
            ].filter(Boolean)}
        />
    );
};

export default GroupSuggest;
